import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Crown, Flame, Target, Award, ArrowRight } from 'lucide-react';
import CaliLetters from '../components/CaliLetters';

const showcaseTiles = [
  { img: '/products/czekoladki.webp', label: 'Czekoladki THC', to: '/produkt/czekoladki-450', fit: 'contain' },
  { img: '/products/zelki.webp', label: 'Zelki THC', to: '/produkt/zelki-500', fit: 'contain' },
  { img: '/products/menu2.jpg', label: 'Cennik Cali Boyz', to: '/produkty', fit: 'cover' },
  { img: '/products/conez.webp', label: 'Cali Conez', to: '/produkt/conez-nutella-150', fit: 'cover' },
  { img: '/products/tabletki500.png', label: 'Tabletki THC 500MG', to: '/produkt/tabletki-500', fit: 'contain' },
  { img: '/products/tabletki250.webp', label: 'Tabletki THC 250MG', to: '/produkt/tabletki-250', fit: 'contain' },
];

const About = () => {
  return (
    <div className="pt-[74px]">
      <section className="relative border-b border-white/10">
        <div className="absolute inset-0 smoke-red opacity-60" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-16 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <img src="/products/logo-trans.png" alt="Cali Boyz" className="h-24 w-auto mb-6" />
            <h1 className="font-anton text-4xl lg:text-6xl uppercase leading-none mb-4">
              <CaliLetters text="TO NIE PRODUKT." />
              <br />
              <CaliLetters text="TO STYL ŻYCIA." />
            </h1>
            <p className="text-white/70 max-w-md">Cali Boyz narodziło się z pasji do wyjątkowych doznań. Łączymy najwyższą jakość THC z niepowtarzalnym smakiem i ulicznym stylem, który czujesz w każdym detalu.</p>
          </div>
          <div className="relative rounded-3xl overflow-hidden border border-white/10">
            <img src="/products/slide-c.jpg" alt="Cali Boyz styl" className="w-full h-[360px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[{ i: Leaf, t: 'JAKOŚĆ', d: 'Tylko sprawdzone składniki i najwyższa jakość THC.' }, { i: Flame, t: 'MOC', d: 'Mocne i długotrwałe doznania w każdym produkcie.' }, { i: Target, t: 'PRECYZJA', d: 'Dokładnie odmierzone dawki dla pełnej kontroli.' }, { i: Crown, t: 'STYL', d: 'Uliczny, autentyczny klimat Cali Boyz.' }].map((v, i) => (
            <div key={i} className="cb-panel rounded-2xl border border-white/10 p-6 text-center product-card">
              <div className="mx-auto mb-4 h-14 w-14 rounded-full border-2 border-[#a6e22e]/50 grid place-items-center text-[#a6e22e]"><v.i size={24} /></div>
              <h3 className="font-anton uppercase text-lg mb-2">{v.t}</h3>
              <p className="text-white/60 text-sm">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="cb-panel rounded-3xl border border-white/10 p-8 lg:p-12 mt-12 grid lg:grid-cols-2 gap-8 items-center smoke-red">
          <div>
            <Award className="text-[#ffb000] mb-3" size={30} />
            <h2 className="font-anton text-3xl lg:text-4xl uppercase mb-4">
              <CaliLetters text="EDIBLESS NR 1" />
            </h2>
            <p className="text-white/70 mb-4">Setki zadowolonych klientów, tysiące zrealizowanych zamówień. Doskonalimy nasze produkty, by za każdym razem dostarczać quality 420%.</p>
            <p className="text-white/70">Masz dużo stresu w codziennym życiu? Sprawdź nasze produkty, zostaw opinię — a na kolejne zamówienie otrzymasz <span className="text-[#a6e22e] font-semibold">15% rabatu!</span></p>
            <Link to="/produkty" className="btn-green inline-flex items-center gap-2 mt-6 px-6 py-3">Zobacz produkty <ArrowRight size={16} /></Link>
          </div>
          <div className="grid grid-cols-3 gap-3">
            {showcaseTiles.map((tile) => (
              <Link
                key={tile.label}
                to={tile.to}
                aria-label={tile.label}
                className="group aspect-square rounded-xl bg-black/40 border border-white/10 grid place-items-center overflow-hidden transition hover:border-[#a6e22e]/70 hover:shadow-[0_0_24px_rgba(166,226,46,0.18)]"
              >
                <img
                  src={tile.img}
                  alt={tile.label}
                  className={`h-full w-full transition-transform duration-500 group-hover:scale-110 ${tile.fit === 'cover' ? 'object-cover' : 'object-contain p-2'}`}
                />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
